import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LanguageComponent } from './components/language/language.component';
import { allLanguages } from './shared/constants/languages';

const routesLang: Routes = allLanguages.filter((lang) => lang.value !== 'en').map((lang) => {
  return {
    path: lang.value,
    component: LanguageComponent,
    children: [
      { path: '', component: HomeComponent },
    ],
  };
});

const routes: Routes = [
  { path: 'en', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    component: LanguageComponent,
    children: [
      { path: '', component: HomeComponent },
    ],
  },
  ...routesLang,
  { path: '**', redirectTo: '', pathMatch: 'full' },
  { path: '*path', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'ignore',
      scrollPositionRestoration: 'enabled',
      useHash: false,
      initialNavigation: 'enabledBlocking',
      urlUpdateStrategy: 'eager',
      scrollOffset: [0, 20],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
